/**
 * Which 401s send the user back to /login.
 * Kept apart from api.tsx so it can be tested without importing axios (see apiErrorCode.ts).
 */

/**
 * Endpoints whose 401 must not boot the user to /login:
 * - login itself, and optional endpoints whose failure shouldn't end the session;
 * - init-password and reset-password, which authenticate with the one-shot token from the
 *   emailed link. Their 401 means the link is dead (`token_expired` / `token_invalid`), and the
 *   page has to stay up to say so. Redirecting dropped the user on the login page instead.
 */
export const NO_REDIRECT_ON_401 = [
  "/auth/distributor-user/login",
  "/auth/distributor-user/init-password",
  "/auth/distributor-user/reset-password",
  "/distributor-dashboard/partner-config",
];

export function shouldRedirectToLogin(requestUrl: string | undefined, status: number | undefined): boolean {
  if (status !== 401) return false;
  const skipRedirect = !!requestUrl && NO_REDIRECT_ON_401.some((path) => requestUrl.includes(path));
  return !skipRedirect;
}
